'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _kunaUtils = require('../../utils/kunaUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The component that shows recording thumbnails,
 * recording reasons, playback, ect
 */
var RecordingDetail = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(RecordingDetail, _Component);

  function RecordingDetail(props) {
    (0, _classCallCheck3.default)(this, RecordingDetail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RecordingDetail.__proto__ || (0, _getPrototypeOf2.default)(RecordingDetail)).call(this, props));

    _this.state = {
      recordingReason: null,
      aiRecording: true,
      nonAiImage: null
    };
    return _this;
  }

  (0, _createClass3.default)(RecordingDetail, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var label = this.props.recording.label;
      var sn = this.props.recording.camera.serial_number;
      var reasonUrl = (0, _kunaUtils.getRecordingReasonUrl)(sn, label);

      // If the camera doesn't have AI - get the GIF
      var getRecordingGif = function getRecordingGif() {
        var thumbUrl = (0, _kunaUtils.getThumbnailUrl)(sn, label);
        fetch(thumbUrl, {
          cache: 'force-cache'
        }).then(function (res) {
          if (res.status === 429 || res.status === 403) {
            return fetch(thumbUrl, { cache: 'reload' });
          }
          return res;
        }).then(function (res) {
          res.arrayBuffer().then(function (buffer) {
            var imageStr = (0, _kunaUtils.arrayBufferToBase64)(buffer);
            _this2.setState({ nonAiImage: 'data:image/jpeg;base64,' + imageStr });
          });
        });
      };

      fetch(reasonUrl, {
        cache: 'force-cache'
      }).then(function (res) {
        if (res.status === 429 || res.status === 403) {
          return fetch(reasonUrl, { cache: 'reload' });
        }
        if (res.status === 404) {
          _this2.setState({ aiRecording: false });
          getRecordingGif();
          throw new Error('No AI');
        }
        return res;
      }).then(function (response) {
        return response.json();
      }).then(function (jsonResponse) {
        // Store response data in list...
        _this2.setState({ recordingReason: jsonResponse });
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // if (this.props.onUpdate) {
      //   this.props.onUpdate();
      // }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          recording = _props.recording,
          showOverlay = _props.showOverlay;
      var _state = this.state,
          playVideo = _state.playVideo,
          nonAiImage = _state.nonAiImage;


      var recordingReason = this.state.recordingReason;

      var imageRatio = 16.0 / 9.0;

      var imageHeight = 200;
      var imageWidth = imageHeight * imageRatio;

      var recordingUrl = '/api/django/cameras/' + this.props.recording.camera.serial_number + '/recordings/' + this.props.recording.label + '/mp4/';

      var recordingReasonSafe = recordingReason || {};
      var sightImageB64 = recordingReasonSafe.image_b64,
          objectReasons = recordingReasonSafe.objects,
          reasonRest = (0, _objectWithoutProperties3.default)(recordingReasonSafe, ['image_b64', 'objects']);


      var aiElement = function aiElement() {
        return !playVideo && _react2.default.createElement(
          'div',
          { style: { position: 'fixed' } },
          _react2.default.createElement('img', {
            height: imageHeight,
            alt: '',
            src: 'data:image/jpeg;base64,' + sightImageB64
          }),
          objectReasons.map(function (obj, idx) {
            return _react2.default.createElement(_components.DetectionBox
            /* eslint-disable-next-line react/no-array-index-key */
            , { key: idx,
              detectionObj: obj,
              recordingReason: reasonRest,
              imageHeight: imageHeight,
              imageWidth: imageWidth
            });
          })
        );
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          {
            title: (0, _stringify2.default)(reasonRest, null, 2),
            style: { width: imageWidth }
          },
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'b',
              null,
              recording.label
            ),
            this.state.aiRecording && ' (AI)',
            _react2.default.createElement(
              'button',
              {
                type: 'button',
                style: { float: 'right' },
                onClick: function onClick() {
                  return showOverlay(
                  /* eslint-disable-next-line */
                  _react2.default.createElement(
                    'video',
                    {
                      controls: 'controls',
                      width: 888,
                      height: 500,
                      style: { height: '500px' },
                      autoPlay: true
                    },
                    _react2.default.createElement('source', { src: recordingUrl, type: 'video/mp4' })
                  ));
                }
              },
              '\u25B6'
            )
          )
        ),
        recordingReason && aiElement(),
        nonAiImage && _react2.default.createElement('img', { height: imageHeight, alt: '', src: nonAiImage })
      );
    }
  }]);
  return RecordingDetail;
}(_react.Component), _class.propTypes = {
  showOverlay: _react.PropTypes.func,
  recording: _react.PropTypes.object
}, _temp);
exports.default = RecordingDetail;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/RecordingDetail/RecordingDetail.js
 ** module id = 1385
 ** module chunks = 0
 **/